export default __webpack_public_path__ + "static/residential-demolition-single-269372dd77738a3ffaada2be6c192ffa.jpg";